import routeMeta from "./routeMeta.json";

export const SITE_URL = "https://delainafernandes.com";
export const SITE_NAME = "Delaina Fernandes";
export const OG_IMAGE = `${SITE_URL}/og-card.png`;

// routeMeta.json is shared with scripts/generate-sitemap.js so the sitemap and
// the runtime tags can never drift apart. Re-bound to a local const rather
// than re-exported: `export { routeMeta }` reads as a re-export through a JSON
// module, which webpack cannot resolve to a named export.
export const ROUTE_META = routeMeta;
export const DEFAULT_META = routeMeta["/"];
